import { Injectable } from '@angular/core';

const SCHEME_PDF_PRIMARY = 'SCHEME-PDF-PRIMARY';
const SCHEME_PDF_SECONDARY = 'SCHEME-PDF-SECONDARY';

export interface SchemePdf {
    primary: string[];
    secondary: string[];
}

export interface EnvironmentDiff {
    added: {
        'SCHEME-PDF'?: string;
        [SCHEME_PDF_PRIMARY]?: string;
        [SCHEME_PDF_SECONDARY]?: string;
        'TYPE-OF-ORDER': string;
    };
    removed: {};
    modified: {
        'SCHEME-PDF'?: EnvironmentDiffModified;
        [SCHEME_PDF_PRIMARY]?: EnvironmentDiffModified;
        [SCHEME_PDF_SECONDARY]?: EnvironmentDiffModified;
        'TYPE-OF-ORDER': EnvironmentDiffModified;
    };
}

export interface EnvironmentDiffModified {
    removed?: string[];
    added?: { value: string }[];
}

interface EnvironmentDiffCache {
    orderType: string;
}

@Injectable({
    providedIn: 'root',
})
export class EnvironmentDiffService {
    private cache: EnvironmentDiffCache = {
        orderType: '',
    };

    public clearCache() {
        this.cache = { orderType: '' };
    }

    public getCurrentSchemes(environmentDiff: EnvironmentDiff): SchemePdf {
        if (environmentDiff?.added[SCHEME_PDF_PRIMARY] || environmentDiff?.added[SCHEME_PDF_SECONDARY]) {
            const primary = (environmentDiff.added[SCHEME_PDF_PRIMARY] || '').split(';');
            const secondary = (environmentDiff.added[SCHEME_PDF_SECONDARY] || '').split(';');
            return { primary, secondary };
        }
        if (environmentDiff?.modified[SCHEME_PDF_PRIMARY] || environmentDiff?.modified[SCHEME_PDF_SECONDARY]) {
            const primary = this.getModified(environmentDiff.modified[SCHEME_PDF_PRIMARY]);
            const secondary = this.getModified(environmentDiff.modified[SCHEME_PDF_SECONDARY]);
            return { primary, secondary };
        }
        return undefined;
    }

    public updateOrderTypeInCache(environmentDiff: EnvironmentDiff) {
        this.cache.orderType = this.getOrderType(environmentDiff);
    }

    public getOrderTypeFromCache() {
        return this.cache.orderType;
    }

    public getOrderType(environmentDiff: EnvironmentDiff): string {
        if (environmentDiff?.added['TYPE-OF-ORDER']) {
            return environmentDiff.added['TYPE-OF-ORDER'];
        }
        if (environmentDiff?.modified['TYPE-OF-ORDER']) {
            return this.getModified(environmentDiff.modified['TYPE-OF-ORDER'])[0];
        }
        return '';
    }

    private getModified(modified: EnvironmentDiffModified) {
        if (modified?.added?.length) {
            return modified.added.map((added) => added.value.split(';')).reduce((prev, curr) => [...prev, ...curr], []);
        }
        if (modified?.removed?.length) {
            return [];
        }
        return undefined;
    }
}
